module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form__group"
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label) + ": "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: {
      'is-danger': _vm.fileError || _vm.hasError
    },
    attrs: {
      "type": "file",
      "id": "uploadCaptureInputFile",
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": _vm.onFileSelect
    }
  }), _vm._v(" "), (_vm.fileError || _vm.hasError) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "cropImage",
      "clickToClose": false,
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": "600"
    },
    on: {
      "before-open": _vm.resetModalHeight
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "15px"
    }
  }, [_vm._v("Crop Image")]), _vm._v(" "), _c('VueCropper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedFile),
      expression: "selectedFile"
    }],
    ref: "cropper",
    staticStyle: {
      "width": "100%",
      "max-height": "400px"
    },
    attrs: {
      "viewMode": 3,
      "zoomable": false,
      "aspect-ratio": 4 / 3,
      "src": _vm.selectedFile,
      "alt": "Source Image"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "save-race-image"
    },
    on: {
      "click": function($event) {
        _vm.cropImage()
      }
    }
  }, [_vm._v("Save")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e2ccd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/UploadPhoto.vue
// module id = 1684
// module chunks = 1